import { frontendURL } from '../../../helper/URLHelper';
import OrdersIndex from './pages/OrdersIndex.vue';
import OrderDetail from './pages/OrderDetail.vue';
import SalesReportPage from './pages/SalesReportPage.vue';
import AnaSayfa from './pages/AnaSayfa.vue';
import MetaAdsIndex from './pages/MetaAdsIndex.vue';
import MetaAdsReports from './pages/MetaAdsReports.vue';
import AdPilot from './pages/AdPilot.vue';
import GoogleStack from './pages/GoogleStack.vue';
import TeamScorecard from './pages/TeamScorecard.vue';
import MetaAdCampaignDetail from './pages/MetaAdCampaignDetail.vue';
import ProductIntelligence from './pages/ProductIntelligence.vue';
import ProductIntelligenceDetail from './pages/ProductIntelligenceDetail.vue';
import SesliAsistan from './pages/SesliAsistan.vue';
import TrendyolFinance from './pages/TrendyolFinance.vue';
import StoreFinance from './pages/StoreFinance.vue';
import BankLedger from './pages/BankLedger.vue';
import Invoices from './pages/Invoices.vue';
import ConsolidatedPnl from './pages/ConsolidatedPnl.vue';
import SkuProfit from './pages/SkuProfit.vue';
import SocialComments from './pages/SocialComments.vue';
import ReturnCenter from './pages/ReturnCenter.vue';
import CargoRescue from './pages/CargoRescue.vue';
import YorumAjani from './pages/YorumAjani.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/yorum-ajani'),
    name: 'yorum_ajani',
    component: YorumAjani,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/asistan'),
    name: 'sesli_asistan',
    component: SesliAsistan,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/yonetim'),
    name: 'yonetim_anasayfa',
    component: AnaSayfa,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/orders'),
    name: 'orders_index',
    component: OrdersIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/ekip-karnesi'),
    name: 'team_scorecard',
    component: TeamScorecard,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/iade-degisim'),
    name: 'return_center',
    component: ReturnCenter,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/kargo-kurtarma'),
    name: 'cargo_rescue',
    component: CargoRescue,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/satis-raporu'),
    name: 'sales_report_index',
    component: SalesReportPage,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/reklamlar'),
    name: 'meta_ads_index',
    component: MetaAdsIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/reklamlar/raporlar'),
    name: 'meta_ads_reports',
    component: MetaAdsReports,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/reklamlar/pilot'),
    name: 'ad_pilot',
    component: AdPilot,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/google'),
    name: 'google_stack',
    component: GoogleStack,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/finans/trendyol'),
    name: 'trendyol_finance',
    component: TrendyolFinance,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/finans/ticimax'),
    name: 'ticimax_finance',
    component: StoreFinance,
    props: { channel: 'ticimax' },
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/finans/shopify'),
    name: 'shopify_finance',
    component: StoreFinance,
    props: { channel: 'shopify' },
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/finans/banka-defteri'),
    name: 'bank_ledger',
    component: BankLedger,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/finans/fatura'),
    name: 'invoices',
    component: Invoices,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/finans/kar-zarar'),
    name: 'consolidated_pnl',
    component: ConsolidatedPnl,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/finans/urun-fiyat'),
    name: 'sku_profit',
    component: SkuProfit,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/sosyal-medya/instagram'),
    name: 'social_instagram',
    component: SocialComments,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/reklamlar/urun-zekasi'),
    name: 'product_intel_index',
    component: ProductIntelligence,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/reklamlar/urun-zekasi/:code'),
    name: 'product_intel_detail',
    component: ProductIntelligenceDetail,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/reklamlar/:id'),
    name: 'meta_ads_detail',
    component: MetaAdCampaignDetail,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/orders/:source/:orderId'),
    component: OrderDetail,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'orders_detail',
        component: OrderDetail,
        meta: commonMeta,
      },
    ],
  },
];
